import { useContext, useMemo } from 'react'
import AppContext from '../../context/AppContext'
import { IJobsRelationship } from '../../ssr/jobSearch'
import { ELanguage } from '@microfrontends/react-components'
import { EMetaJobs } from '../../services/Jobs/@type'

interface IProps {
	title: string
	jobs: IJobsRelationship[]
	type?: EMetaJobs
}

interface ILocationName {
	name?: string | null
	nameEn?: string | null
}
const vnwBaseUrl = process.env.VNW_BASE_URL ?? ''

export default function SitemapBlock({ jobs, title, type }: IProps) {
	const { languageCode } = useContext(AppContext)

	const renderLocationName = ({ name, nameEn }: ILocationName) => {
		if (!name) return ''

		switch (type) {
			case EMetaJobs.cities:
				if (languageCode === ELanguage.VI) {
					return `Việc làm ${name}`
				}

				return `Jobs in ${nameEn}`
			default:
				if (languageCode === ELanguage.VI) {
					return name
				}

				return nameEn
		}
	}

	return (
		<div className='box'>
			<h5>{title}</h5>
			<div className='boxContent'>
				<ul>
					{jobs.map((item, index) => {
						let itemUrl = item?.url ?? ''

						if (item?.url && item?.url?.indexOf('-kw') > 0) {
							const slug = item?.url.replace(vnwBaseUrl, '').replace('-kw', '').replace('/', '')
							itemUrl = `${vnwBaseUrl}/jobs?q=${slug}`
						}

						return (
							<li key={index}>
								<a
									href={itemUrl}
									target='blank'
									title={item.title ?? ''}
								>
									{renderLocationName({ ...item })}
								</a>
							</li>
						)
					})}
				</ul>
			</div>
		</div>
	)
}
